export enum SyncStatusOverride {
  ALLOW_SYNC = 'ALLOW_SYNC',
  DENY_SYNC = 'DENY_SYNC',
  NO_OVERRIDE = 'NO_OVERRIDE',
}
